(() => {
  const COLLAPSE_THRESHOLD = 4;
  const CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initCustomTextCollapse(root = document) {
    root.querySelectorAll('.product__info-container ul.custom_text').forEach((list) => {
      if (list.dataset.collapseReady === 'true') return;

      const items = list.querySelectorAll(':scope > li');
      if (items.length <= COLLAPSE_THRESHOLD) return;

      list.dataset.collapseReady = 'true';
      list.classList.add('custom_text--collapsible');

      const wrap = document.createElement('div');
      wrap.className = 'custom_text__wrap';
      list.parentNode.insertBefore(wrap, list);
      wrap.appendChild(list);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'custom_text__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = `<span class="custom_text__toggle-label">Learn more</span>${CHEVRON_SVG}`;

      button.addEventListener('click', () => {
        const expanded = wrap.classList.toggle('is-expanded');
        list.classList.toggle('is-expanded', expanded);
        button.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('.custom_text__toggle-label').textContent = expanded
          ? 'Show less'
          : 'Learn more';
      });

      wrap.appendChild(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomTextCollapse(), { once: true });
  } else {
    initCustomTextCollapse();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomTextCollapse(event.target);
  });
})();
